import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import SubsystemLayout from '../layouts/SubsystemLayout.vue'
import Customers from '../views/Customers.vue'
import InboundDetail from '../views/InboundDetail.vue'
import InboundList from '../views/InboundList.vue'
import Home from '../views/Home.vue'
import Locations from '../views/Locations.vue'
import Login from '../views/Login.vue'
import Oplogs from '../views/Oplogs.vue'
import OutboundDetail from '../views/OutboundDetail.vue'
import Reports from '../views/Reports.vue'
import OutboundList from '../views/OutboundList.vue'
import Profile from '../views/Profile.vue'
import Skus from '../views/Skus.vue'
import StockMoves from '../views/StockMoves.vue'
import Stocks from '../views/Stocks.vue'
import StocktakeDetail from '../views/StocktakeDetail.vue'
import StocktakeList from '../views/StocktakeList.vue'
import Suppliers from '../views/Suppliers.vue'
import Warehouses from '../views/Warehouses.vue'
import WaveDetail from '../views/WaveDetail.vue'
import WaveList from '../views/WaveList.vue'

const ui = (name: 'Forbidden' | 'NotFound' | 'NetworkError' | 'AppUnavailable') => () =>
  import('@yc/ui-kit').then((m) => m[name])

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true, blank: true },
  },
  {
    path: '/',
    component: SubsystemLayout,
    children: [
      { path: '', name: 'home', component: Home, meta: { perm: 'wms:home' } },
      // 个人中心：顶栏「个人中心」下拉项就是 go('/profile')，早期各子系统都漏了这条路由，
      // 点进去落到 /:pathMatch(.*)* 显示「页面不存在」。
      // 不挂 meta.perm：这是登录用户自己的信息页，挂权限码会把没配菜单权限的普通用户弹到 403。
      { path: 'profile', name: 'profile', component: Profile },
      { path: 'locations', name: 'locations', component: Locations, meta: { perm: 'wms:location' } },
      { path: 'warehouses', name: 'warehouses', component: Warehouses, meta: { perm: 'wms:warehouse' } },
      { path: 'skus', name: 'skus', component: Skus, meta: { perm: 'wms:sku' } },
      { path: 'suppliers', name: 'suppliers', component: Suppliers, meta: { perm: 'wms:supplier' } },
      { path: 'customers', name: 'customers', component: Customers, meta: { perm: 'wms:customer' } },
      { path: 'inbound', name: 'inbound', component: InboundList, meta: { perm: 'wms:inbound' } },
      { path: 'outbound', name: 'outbound', component: OutboundList, meta: { perm: 'wms:outbound' } },
      { path: 'stocks', name: 'stocks', component: Stocks, meta: { perm: 'wms:stock' } },
      { path: 'waves', name: 'waves', component: WaveList, meta: { perm: 'wms:wave' } },
      { path: 'stocks/moves', name: 'stock-moves', component: StockMoves, meta: { perm: 'wms:stock' } },
      { path: 'stocktakes', name: 'stocktakes', component: StocktakeList, meta: { perm: 'wms:stocktake' } },
      { path: 'inbound/:id', name: 'inbound-detail', component: InboundDetail, meta: { perm: 'wms:inbound' } },
      { path: 'outbound/:id', name: 'outbound-detail', component: OutboundDetail, meta: { perm: 'wms:outbound' } },
      { path: 'waves/:id', name: 'wave-detail', component: WaveDetail, meta: { perm: 'wms:wave' } },
      { path: 'stocktakes/:id', name: 'stocktake-detail', component: StocktakeDetail, meta: { perm: 'wms:stocktake' } },
      { path: 'reports', name: 'reports', component: Reports, meta: { perm: 'wms:report' } },
      { path: 'oplogs', name: 'oplogs', component: Oplogs, meta: { perm: 'wms:oplog' } },
      { path: '403', name: 'forbidden', component: ui('Forbidden') },
    ],
  },
  {
    // 放在鉴权布局之外：企业被停用（40303）时 /me 本身就会失败，若仍走布局，
    // 外壳会继续发注定失败的请求，且守卫每次都判定"未登录"从而在登录页与本页之间死循环。
    path: '/app-unavailable',
    name: 'app-unavailable',
    component: ui('AppUnavailable'),
    meta: { public: true, blank: true },
    props: (route) => ({
      code: Number(route.query.code ?? 40301),
      msg: String(route.query.msg ?? ''),
    }),
  },
  {
    path: '/network-error',
    name: 'network-error',
    component: ui('NetworkError'),
    meta: { public: true, blank: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: ui('NotFound'),
    meta: { public: true, blank: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
